import { render, staticRenderFns } from "./Challenge.vue?vue&type=template&id=7b7e2dc4&scoped=true"
import script from "./Challenge.vue?vue&type=script&lang=js"
export * from "./Challenge.vue?vue&type=script&lang=js"
import style0 from "./Challenge.vue?vue&type=style&index=0&id=7b7e2dc4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b7e2dc4",
  null
  
)

export default component.exports